<template>
  <!-- <div> -->
  <div ref="chartc1" style="width: 368px; height: 203px"></div>
  <!-- </div> -->
</template>

<script>
const echarts = require("echarts");
export default {
  components: {
    // Seacher,
  },
  data() {
    return {
      value: "",
    };
  },
  mounted() {
    // this.getchartsdata();
    this.initChartsc1();
  },
  destroyed() {},
  methods: {
    initChartsc1() {
      this.lineChart = echarts.init(this.$refs.chartc1);
      var data = [
        { value: 1048, name: "USDT Token" },
        { value: 735, name: "LF8iBW9y1KL...pMszf" },
        { value: 580, name: "FTH-DC Token" },
        { value: 484, name: "DCT Token" },
        { value: 300, name: "LFdko4yMVrK...9D7iA" },
        { value: 300, name: "S-USDT-TRX Token" },
        { value: 300, name: "USDT Token" },
      ];

      let option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          show: false,
          orient: "vertical",
          x: "40%", //可设定图例在左、右、居中
          y: "center",
          icon: "circle",
          padding: [0, 50, 0, 0],
          itemHeight: 6, // 图例icon高度
          itemWidth: 6, // 图例icon宽度
          align: "left", // 图例icon在左侧
          formatter: function (name) {
            // 添加
            let total = 0;
            let target;
            for (let i = 0; i < data.length; i++) {
              total += data[i].value;
              if (data[i].name === name) {
                target = data[i].value;
              }
            }
            var arr = [
              "{a|" + name + "}",

              "{c|" + target + " " + "calls" + "}",
              "{b|" + ((target / total) * 100).toFixed(2) + "%}",
            ];
            return arr.join("  ");
          },
          textStyle: {
            // 添加
            padding: [8, 0, 0, 0],
            rich: {
              a: {
                fontSize: 15,
                width: 180,
                color: "#fff",
              },
              b: {
                fontSize: 15,
                width: 80,
                color: "#c1c1c1",
              },
              c: {
                fontSize: 15,
                color: "#fff",
                width: 80,
              },
            },
          },
        },
        graphic: [
          {
            type: "text",
            left: "45%",
            top: "28%",
            style: {
              text: "Total\n",
              textAlign: "center", //水平居中
              fill: "#91979D", //字体颜色
              width: 50,
              height: 30,
              font: '16px "PingFang SC-Medium, PingFang SC"', //字体大小
            },
          },
          {
            type: "text",
            left: "40%",
            top: "40%",
            style: {
              // text: '总数',
              text:
                data.reduce((n, i) => {
                  return (n += i.value);
                  // var numa=(n += i.value);
                  // return numa+'m',
                }, 0) + "m",

              textAlign: "center",
              fill: "#fff",
              width: 30,
              height: 30,
              font: '24px "D-DIN-Bold,D-DIN"', //字体大小
            },
          },
          {
            type: "text",
            left: "45%",
            top: "56%",
            style: {
              text: "Calls\n",
              textAlign: "center", //水平居中
              fill: "#91979D", //字体颜色
              width: 50,
              height: 30,
              font: '16px "PingFang SC-Medium, PingFang SC"', //字体大小
            },
          },
        ],

        color: [
          "#00E79A",
          "#FFC302",
          "#A952FF",
          "#48D3E2",
          "#F76C9C",
          "#7C9FFC",
          "#9E3820",
        ],
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["50%", "70%"],
            center: ["50%", "45%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            label: {
              normal: {
                show: true,
                position: "center",
                hoverAnimation: false,
                scale: false,
                textStyle: {
                  fontSize: 15,
                  color: "#00A870",
                  hoverAnimation: false,
                },
                emphasis: {
                  scale: false,
                  hoverAnimation: false,
                  label: {
                    show: false,
                    fontSize: "12",
                    fontWeight: "bold",
                  },
                },
              },
            },

            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: 12,
                fontWeight: "bold",
              },
            },
            data: data,
          },
        ],
      };

      this.lineChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped></style>
